import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../Pages/Auth/Login";
import Register from "../Pages/Auth/Register";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import VerifyEmail from "Pages/Auth/VerifyEmail";
import { ProfilePreview } from "Pages/ProfilePreview/ProfilePreview";
import { ForgotPassword } from "Pages/Auth/ForgotPassword";
import { ResetPassword } from "Pages/Auth/ResetPassword";
import Dashboard from "Pages/Dashboard/Dashboard";

let PrivateRoutes = [
  {
    path: "profile",
    element: <Dashboard />,
  },
];

let nonLoggedInRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/confirm-signup",
    element: <VerifyEmail />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
];

export const RenderRoutes = () => {
  const { token } = useSelector((state) => state?.auth);

  return (
    <BrowserRouter>
      <Routes>
        {nonLoggedInRoutes?.map((item, index) => (
          <Route
            path={item?.path}
            key={index}
            element={<PublicRoute element={item?.element} token={token} />}
          />
        ))}
        {PrivateRoutes?.map((item, index) => (
          <Route
            path={item?.path}
            key={index}
            element={<PrivateRoute element={item?.element} token={token} />}
          />
        ))}
        <Route path={"profile-preview"} element={<ProfilePreview />} />
        <Route element={<Navigate to={"/login"} />} path="*" />
      </Routes>
    </BrowserRouter>
  );
};
